/**
 * ID card statuses
 *
 * @package HOPS
 * @subpackage Cards
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
class CardStatus {

	/**
	 * Get a status value's highlight colour.
	 * 
	 * @param {Integer} status
	 * @return {String|undefined} CSS colour
	 */
	static getColour(status) {
		switch (status) {
			case this.values.Live:
				return "green";
			case this.values.Expired:
			case this.values.Cancelled:
			case this.values.Lost:
			case this.values.Stolen:
				return "red";
			default:
				return undefined;
		}
	}


	/**
	 * Status values
	 *
	 * @type {Object}
	 */
	static values = {

		Unknown: 0,

		Generated: 1,

		Approved: 2,

		Live: 3,

		Expired: 4,

		Lost: 5,

		Cancelled: 6,

		Stolen: 7

	};

}

export default CardStatus;
